import React from "react";
import { AxiosResponse } from "axios";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";

import { IMaster } from "app/api/types";
import {
  getMasters,
  addMaster,
  delMaster,
  editMaster
} from "app/api/redux/Masters/actions";
import MasterList from "app/components/MasterList";
import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";

interface IProps extends RouteComponentProps<{ id: string }> {
  masterList: IMaster[];
  isLoading: boolean;
  getMasters: () => Promise<AxiosResponse>;
  addMaster: (data: IMaster) => Promise<AxiosResponse>;
  delMaster: (email: IMaster["email"]) => Promise<AxiosResponse>;
  editMaster: (data: IMaster) => Promise<AxiosResponse>;
}

class MastersPage extends React.Component<IProps> {
  componentDidMount() {
    this.props.getMasters().catch(err => {
      console.log(err);
      this.props.history.push("/404");
    });
  }

  render() {
    return (
      <LayoutUser>
        <MasterList
          masterList={this.props.masterList}
          isLoading={this.props.isLoading}
          addMaster={this.props.addMaster}
          delMaster={this.props.delMaster}
          editMaster={this.props.editMaster}
          getMasters={this.props.getMasters}
        />
      </LayoutUser>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    masterList: state.masters.masterList,
    isLoading: state.masters.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, { getMasters, addMaster, delMaster, editMaster })(
    MastersPage
  )
);
